import React, { useState, useEffect, useRef } from 'react';

// Default icons for each card type
const defaultIcons = {
  "Free Live Training": (
    <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Browser Window 1 */}
      <rect x="20" y="20" width="140" height="100" stroke="#FBBF24" strokeWidth="3" rx="4" fill="none"/>
      <circle cx="35" cy="35" r="3" fill="#FBBF24"/>
      <circle cx="45" cy="35" r="3" fill="#FBBF24"/>
      <circle cx="55" cy="35" r="3" fill="#FBBF24"/>
      
      {/* Browser Window 2 (overlapping) */}
      <rect x="40" y="60" width="140" height="100" stroke="#FBBF24" strokeWidth="3" rx="4" fill="none"/>
      <circle cx="55" cy="75" r="3" fill="#FBBF24"/>
      <circle cx="65" cy="75" r="3" fill="#FBBF24"/>
      <circle cx="75" cy="75" r="3" fill="#FBBF24"/>
      
      {/* Play Button */}
      <circle cx="100" cy="90" r="20" fill="#FBBF24"/>
      <path d="M95 85 L95 95 L105 90 Z" fill="black"/>
    </svg>
  ),
  "Our Accelerators": (
    <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Person */}
      <circle cx="60" cy="70" r="25" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <rect x="40" y="95" width="40" height="60" rx="20" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      
      {/* Chart Window */}
      <rect x="100" y="40" width="80" height="100" stroke="#FBBF24" strokeWidth="3" rx="4" fill="none"/>
      <circle cx="110" cy="50" r="2" fill="#FBBF24"/>
      <circle cx="120" cy="50" r="2" fill="#FBBF24"/>
      <circle cx="130" cy="50" r="2" fill="#FBBF24"/>
      
      {/* Bar Chart */}
      <rect x="110" y="70" width="8" height="30" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <rect x="125" y="60" width="8" height="40" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <rect x="140" y="65" width="8" height="35" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <rect x="155" y="55" width="8" height="45" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      
      {/* Line Graph */}
      <path d="M115 95 L130 85 L145 90 L160 80" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <circle cx="115" cy="95" r="3" fill="#FBBF24"/>
      <circle cx="160" cy="80" r="3" fill="#FBBF24"/>
    </svg>
  ),
  "Get More Leads": (
    <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer Circle */}
      <circle cx="100" cy="100" r="70" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <path d="M 100 30 A 70 70 0 0 1 170 100" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <path d="M 170 100 A 70 70 0 0 1 100 170" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <path d="M 100 170 A 70 70 0 0 1 30 100" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <path d="M 30 100 A 70 70 0 0 1 100 30" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      
      {/* Middle Circle */}
      <circle cx="100" cy="100" r="45" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <path d="M 100 55 A 45 45 0 0 1 145 100" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <path d="M 145 100 A 45 45 0 0 1 100 145" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <path d="M 100 145 A 45 45 0 0 1 55 100" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <path d="M 55 100 A 45 45 0 0 1 100 55" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      
      {/* Inner Circle with % */}
      <circle cx="100" cy="100" r="25" fill="#1A202C"/>
      <text x="100" y="110" textAnchor="middle" fill="white" fontSize="20" fontWeight="bold">%</text>
    </svg>
  ),
  "KPI Score": (
    <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Dashboard/Score Card */}
      <rect x="30" y="40" width="140" height="120" stroke="#FBBF24" strokeWidth="3" rx="4" fill="none"/>
      <circle cx="45" cy="55" r="2" fill="#FBBF24"/>
      <circle cx="52" cy="55" r="2" fill="#FBBF24"/>
      <circle cx="59" cy="55" r="2" fill="#FBBF24"/>
      
      {/* Score Display */}
      <rect x="50" y="75" width="100" height="60" stroke="#FBBF24" strokeWidth="2" rx="4" fill="none"/>
      <text x="100" y="115" textAnchor="middle" fill="#FBBF24" fontSize="32" fontWeight="bold">85</text>
      
      {/* Upward Arrow */}
      <path d="M100 140 L100 165 M100 165 L85 150 M100 165 L115 150" stroke="#FBBF24" strokeWidth="3" fill="none" strokeLinecap="round"/>
    </svg>
  ),
  "Books & Resources": (
    <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Books Stack */}
      <rect x="50" y="60" width="80" height="100" stroke="#FBBF24" strokeWidth="3" rx="2" fill="none"/>
      <line x1="70" y1="80" x2="110" y2="80" stroke="#FBBF24" strokeWidth="2"/>
      <line x1="70" y1="95" x2="110" y2="95" stroke="#FBBF24" strokeWidth="2"/>
      <line x1="70" y1="110" x2="110" y2="110" stroke="#FBBF24" strokeWidth="2"/>
      
      {/* Second Book */}
      <rect x="65" y="50" width="70" height="90" stroke="#FBBF24" strokeWidth="3" rx="2" fill="none"/>
      <line x1="80" y1="70" x2="115" y2="70" stroke="#FBBF24" strokeWidth="2"/>
      <line x1="80" y1="85" x2="115" y2="85" stroke="#FBBF24" strokeWidth="2"/>
      
      {/* Bookmark */}
      <path d="M105 40 L105 80 L95 70 L85 80 L85 40 Z" stroke="#FBBF24" strokeWidth="2" fill="#FBBF24"/>
    </svg>
  ),
  "Coaching & Mentoring": (
    <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Person 1 (Left) */}
      <circle cx="70" cy="70" r="20" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <rect x="55" y="90" width="30" height="50" rx="15" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      
      {/* Person 2 (Right) */}
      <circle cx="130" cy="70" r="20" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      <rect x="115" y="90" width="30" height="50" rx="15" stroke="#FBBF24" strokeWidth="3" fill="none"/>
      
      {/* Connection/Speech Bubble */}
      <path d="M90 50 Q100 40 110 50" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <ellipse cx="100" cy="35" rx="25" ry="15" stroke="#FBBF24" strokeWidth="2" fill="none"/>
      <line x1="100" y1="30" x2="100" y2="25" stroke="#FBBF24" strokeWidth="2"/>
    </svg>
  )
};

// A very simple generic icon used as a final fallback
const genericIcon = (
  <svg className="w-full h-full" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="100" cy="100" r="70" stroke="#FBBF24" strokeWidth="3" fill="none"/>
    <path d="M100 45 L115 95 L165 95 L125 125 L140 175 L100 145 L60 175 L75 125 L35 95 L85 95 Z" stroke="#FBBF24" strokeWidth="3" fill="none"/>
  </svg>
);

// Normalize a string so icon lookup is resilient to title edits
const normalizeKey = (value) => (value || '').toString().trim().toLowerCase();

// Build a normalized lookup once
const normalizedIconMap = Object.fromEntries(
  Object.entries(defaultIcons).map(([k, v]) => [normalizeKey(k), v])
);

const ServicesCardsSection = ({
  cards = []
}) => {
  const [animationKey, setAnimationKey] = useState(0);
  const sectionRef = useRef(null);
  const wasIntersectingRef = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !wasIntersectingRef.current) {
            // Only trigger animation when entering viewport (not already visible)
            setAnimationKey(prev => prev + 1);
            wasIntersectingRef.current = true;
          } else if (!entry.isIntersecting) {
            // Reset flag when leaving viewport to allow re-animation
            wasIntersectingRef.current = false;
          }
        });
      },
      {
        threshold: 0.1, // Trigger when 10% of the section is visible
        rootMargin: '0px 0px -50px 0px' // Trigger slightly before it's fully in view
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
      observer.disconnect();
    };
  }, []);

  // Merge provided cards with default icons if icon is not provided
  const cardsWithIcons = cards.map(card => {
    const key = normalizeKey(card.iconKey || card.title);
    const resolvedIcon = card.icon ?? normalizedIconMap[key] ?? genericIcon;
    return {
      ...card,
      icon: resolvedIcon,
    };
  });

  return (
    <div ref={sectionRef} className="bg-white py-16 lg:py-20 w-full">
      <div className="w-full max-w-7xl mx-auto px-4 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-10 lg:mb-14">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
            Here are the services we offer.
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {cardsWithIcons.map((card, index) => (
            <div
              key={`${animationKey}-${index}`}
              className={`group bg-hero-bg rounded-lg p-8 lg:p-12 flex flex-col items-center text-center space-y-6 transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl hover:shadow-accent-yellow/20 cursor-pointer fade-in-up`}
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              {/* Icon */}
              {card.icon && (
                <div className="w-32 h-32 lg:w-40 lg:h-40 flex items-center justify-center transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                  <div className="transition-all duration-300 group-hover:drop-shadow-[0_0_20px_rgba(251,191,36,0.5)]">
                    {card.icon}
                  </div>
                </div>
              )}
              
              {/* Title */}
              <h3 className="text-white text-xl lg:text-2xl font-bold transition-colors duration-300 group-hover:text-accent-yellow">
                {card.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesCardsSection;